'use strict';

import _ from 'lodash';

import React, { Component } from 'react';
import RoundButton from 'ck-core-client/source/ui/RoundButton';

let BUTTON_STATE;

export default class BillingRestrictedPanel extends Component {
	constructor(props) {
		super(props);

		this.state = {
			buttonState: BUTTON_STATE.READY,
			buttonText: 'Resend Billing Link',
			errorMessage: null
		};
	}

	async resendBillingLink() {
		this.setState({
			buttonState: BUTTON_STATE.PENDING
		});

		try {
			await CK.clientSockets.users.emit('resendBillingLink');
		} catch (error) {
			this.setState({
				errorMessage: error.message
			});

			this.setState({
				buttonState: BUTTON_STATE.ERROR
			});
		}

		this.setState({
			buttonState: BUTTON_STATE.DONE,
			buttonText: 'Done'
		});
	}

	render() {
		const buttonProps = {
			disabled: !_.includes([BUTTON_STATE.READY, BUTTON_STATE.ERROR], this.state.buttonState),
			pending: this.state.buttonState === BUTTON_STATE.PENDING,
			text: this.state.buttonText,
			handleClick: this.resendBillingLink.bind(this)
		};

		return (
			<div>
				<p id={'billingRestrictionWarning'}>
					Were you looking for billing information? Follow the link in your billing confirmation
					email.
				</p>
				<RoundButton buttonId={'resendBillingLink'} {...buttonProps} />
				{this.state.errorMessage && <p className="errorMessage">{this.state.errorMessage}</p>}
			</div>
		);
	}
}
BUTTON_STATE = {
	// Submitting
	PENDING: 'pending',

	// Just had an error
	ERROR: 'error',

	// Can be pressed
	READY: 'ready',

	// Just done; show good status
	DONE: 'done'
};
